import { Modal, ModalBody } from "reactstrap"
import PropTypes from "prop-types"
import Lottie from "react-lottie"
import * as animationData from "../../../assets/76705-error-animation.json"
import { useSelector } from "react-redux"

const WarningModal = ({
  isModal,
  messageType,
  expr,
  checkbox,
  files,
  iban,
  name,
  surname,
  errorMessage,
  toggleWarningModal,
  messageTitle
}) => {
  const file_number = useSelector((state) => state.FileNumber.value)
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  const warningText = () => {

    console.log("name:", name)
    console.log("surname:", surname)

    console.log("expr:", expr)
    console.log("iban:", iban?.length)

    console.log("messageType:", messageType)

    console.log("file_number:", file_number)
    console.log("files?.length:", files?.length)

    console.log("checkbox:", checkbox)

    if (messageType === "failed_name_surname") {
      return <p>Lütfen Adınızı ve Soyadınızı giriniz.</p>
    }
    if (messageType === "failed_iban") {
      return <p>IBAN bilgisini eksik ya da hatalı girdiniz. Lütfen kontrol edip tekrar deneyin.</p>
    }
    if (messageType === "failed_files") {
      return <p>Tüm belgeleri eksiksiz olarak yüklemeniz gerekmektedir.</p>
    }
    if (messageType === "file") {
      return <p>Yüklemek istediğiniz dosya .jpg, .jpeg, .png veya .pdf uzantılı olmalıdır.</p>
    }
    if (messageType === "ownerFileType") {
      return <p>Aynı resmi bir daha yükleyemezsiniz</p>
    }
    if (messageType === "failed_agreement") {
      return <p>Başvuruyu tamamlamak için kullanım koşullarını kabul etmeniz gerekmektedir.</p>
    }
    if (messageType === "server_error") {
      return <p>{errorMessage}</p>
    }
  }

  return (
    <div>
      <Modal centered isOpen={isModal} toggle={toggleWarningModal}>
        <ModalBody
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            lineHeight: 1,
          }}
        >
          <div
            style={{ with: "100%", marginBottom: "1rem", marginTop: "0.5rem" }}
          >
            <Lottie options={defaultOptions} height={75} width={75} />
          </div>
          <p
            style={{
              fontWeight: "bolder",
              fontSize: 25,
            }}
          >
            {messageTitle ? messageTitle : "Uyarı"}
          </p>
          <div style={{ textAlign: "center" }}>{warningText()}</div>
        </ModalBody>
      </Modal>
    </div>
  )
}

WarningModal.propTypes = {
  isModal: PropTypes.bool,
  onFinish: PropTypes.func,
  expr: PropTypes.bool,
  checkbox: PropTypes.bool,
  files: PropTypes.array,
}

export default WarningModal
